// Date-range helpers for list filters whose values come from <input type="date"> (YYYY-MM-DD).

// True when both ends are set and the end date is before the start date. Same-day ranges are valid.
// YYYY-MM-DD strings compare correctly as plain strings.
export const isInvalidDateRange = (from, to) => !!from && !!to && to < from;

// Builds "&<name>From=...&<name>To=..." for an inclusive whole-day range. An open end is padded
// the same way as the other InCBot date filters (2000-01-01 / 3000-12-31). Returns "" when no end
// is set or the range is invalid, so an invalid range never reaches the API.
export const buildDateRangeQuery = (name, from, to) => {
  if ((!from && !to) || isInvalidDateRange(from, to)) return "";
  const start = from ? `${from}T00:00:00` : "2000-01-01T00:00:00";
  const end = to ? `${to}T23:59:59` : "3000-12-31T23:59:59";
  return `&${name}From=${start}&${name}To=${end}`;
};
